import React from 'react';
import { observer } from 'src/utils/mobx-react';

import {
    TableWrapper,
    TableHeaderRow,
    TableHeaderCell,
    TableBodyCell,
    TableBodyRow,
    TableLink,
} from 'src/components/TranslationsContent/AllLanguages/AllLanguages.style';
import { TranslationsContentState } from 'src/components/TranslationsContent/TranslationsContent.state';
import { getLanguageName } from 'src/components/TranslationsContent/languages';

const sortByLangName = (a: langName, b: langName): number => {
    const langA = getLanguageName(a[0]);
    const langB = getLanguageName(b[0]);

    if (langA < langB) {
        return -1;
    }
    if (langA > langB) {
        return 1;
    }

    return 0;
};

type langName = [
    string,
    {
        updatedAt: string;
        properties: Record<string, string>;
    },
];

interface AllLanguagesPropsType {
    state: TranslationsContentState;
}

const LanguageTableBody = observer('LanguageTableBody', (props: AllLanguagesPropsType): JSX.Element | null => {
    const translations = props.state.translations;

    if (translations === null) {
        return null;
    }

    const onLanguageClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();
        const dataLang = e.currentTarget.getAttribute('data-language');
        props.state.selectLanguage(dataLang);
    };

    const tbody = [];

    for (const [language, obj] of Object.entries(translations).sort(sortByLangName)) {
        const numProperties = Object.keys(obj.properties).length;

        if (numProperties > 0) {
            props.state.setTranslationAvailable();
        }

        const tr = (
            <TableBodyRow key={language}>
                <TableBodyCell>
                    <TableLink href='#' onClick={onLanguageClick} data-language={language}>
                        {getLanguageName(language)}
                    </TableLink>
                </TableBodyCell>
                <TableBodyCell>{numProperties}</TableBodyCell>
                <TableBodyCell>{obj.updatedAt}</TableBodyCell>
                <TableBodyCell>
                    <TableLink href={`/api/translations/${props.state.groupName}/csv/${language}`} download>
                        Export CSV
                    </TableLink>
                </TableBodyCell>
            </TableBodyRow>
        );
        tbody.push(tr);
    }

    return <tbody>{tbody}</tbody>;
});

export const AllLanguages = observer(
    'AllLanguages',
    (props: AllLanguagesPropsType): JSX.Element => (
        <TableWrapper>
            <thead>
                <TableHeaderRow>
                    <TableHeaderCell>Language</TableHeaderCell>
                    <TableHeaderCell>Unique Phrases</TableHeaderCell>
                    <TableHeaderCell>Last Updated</TableHeaderCell>
                    <TableHeaderCell>
                        {props.state.hasTranslations === true ? (
                            <a
                                href={`/api/translations/${props.state.groupName}/csv`}
                                download
                                className='btn btn-small btn-add'
                            >
                                Export all CSV
                            </a>
                        ) : null}
                    </TableHeaderCell>
                </TableHeaderRow>
            </thead>

            <LanguageTableBody state={props.state} />
        </TableWrapper>
    )
);
